import type { SVGProps } from 'react';

const LogoPlain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    enableBackground="new 0 0 284.24 110.15"
    viewBox="0 0 284.24 110.15"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m114.78 102.8c0 3.3-2.91 5.85-6.18 5.38-4.98-.71-12.05-2.26-19.93-5.59-13.37-5.66-31.7-17.75-43.11-43.24-12.2-27.25-31.75-33.8-41.57-35.35-2.29-.35-3.99-2.31-3.99-4.63v-12.77c0-3.29 2.9-5.83 6.15-5.38 4.67.64 10.7 1.98 17.33 4.72 13 5.36 31.01 17.36 42.97 44.07 12.18 27.2 34.37 33.79 44.38 35.39 2.27.36 3.94 2.33 3.94 4.63z"
      fill="#f86543"
    />
    <g fill="#fff">
      <path d="m128.68 10.51c0-5.97 4.28-10.51 12.07-10.51 7.65 0 12.07 4.54 12.07 10.51 0 5.84-4.67 10.38-12.07 10.38s-12.07-4.54-12.07-10.38z" />
      <path d="m166.87 101.39v-93.1c0-4.6 2.52-7.13 7.13-7.13h8.61c4.6 0 7.28 2.52 7.28 7.13v93.1c0 4.6-2.67 7.13-7.28 7.13h-8.61c-4.61 0-7.13-2.53-7.13-7.13z" />
      <path d="m197.61 68.63c0-22.63 17.01-42.14 44.02-42.14 22.79 0 41.52 13.74 42.61 39.33.16 4.53-2.97 6.56-7.65 6.56h-55.88c-.31 9.52 9.21 18.73 24.66 18.73 5.78 0 11.71-1.4 17.79-4.84 4.21-2.34 7.65-2.03 10.61 1.56l1.72 2.19c3.12 3.75 2.81 7.96-1.4 11.08-9.21 6.71-19.98 9.05-30.28 9.05-28.72 0-46.2-18.57-46.2-41.52zm63.99-9.68c-2.19-10.77-11.39-14.2-19.67-14.2-8.43 0-17.95 3.75-20.6 14.2z" />
      <path d="m129.24 101.39v-63.23c0-4.6 2.52-7.13 7.13-7.13h8.61c4.6 0 7.28 2.52 7.28 7.13v63.23c0 4.6-2.67 7.13-7.28 7.13h-8.61c-4.61 0-7.13-2.53-7.13-7.13z" />
      <path d="m114.63 72.8v-64.51c0-3.94-3.19-7.13-7.13-7.13h-8.76c-3.94 0-7.13 3.19-7.13 7.13v53.54c0 2.35 1.17 4.56 3.14 5.85 6.62 4.32 13.18 6.12 17.81 6.86h.02c1.08.17 2.05-.66 2.05-1.74z" />
      <path d="m0 36.53v64.86c0 3.94 3.19 7.13 7.13 7.13h8.61c4.02 0 7.28-3.26 7.28-7.28v-52.61c0-2.1-.94-4.1-2.57-5.43-6.82-5.58-13.6-7.61-18.17-8.33-.08-.01-.16-.03-.24-.04-1.07-.19-2.04.62-2.04 1.7z" />
    </g>
  </svg>
);
export default LogoPlain;
